import posthog from 'posthog-js'

const isPostHogConfigured = () => Boolean(
  process.env.NODE_ENV === 'production' &&
  process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN &&
  process.env.NEXT_PUBLIC_POSTHOG_HOST
)

export function capturePostHogEvent(eventName, properties) {
  if (!isPostHogConfigured()) return
  posthog.capture(eventName, properties)
}

export function capturePostHogException(error, properties) {
  if (!isPostHogConfigured()) return
  posthog.captureException(error, properties)
}

export function identifyPostHogUser(userId, properties) {
  if (!isPostHogConfigured() || !userId) return
  const currentUserId = posthog.get_property('$user_id')
  if (currentUserId && currentUserId !== userId) {
    posthog.reset()
  }
  posthog.identify(userId, properties)
}
